// @flow

import { connect } from 'react-redux';
import React, { type ComponentType } from 'react';

import { getNextOepYear } from 'client/utils/ede/oepDate';
import { getPeriods } from 'client/actions/date';
import CORE_PRODUCT_TYPES from 'client/constants/productTypes';
import useEnrollmentPeriods from 'client/hooks/enrollmentPeriod/useEnrollmentPeriods';

type Props = {
  address: Object,
  getPeriods: Function,
  onExchange: boolean,
  productType: 'health' | 'vision' | 'dental',
};

const withEnrollmentPeriodsHook = (Component: ComponentType<any>) => {
  const WrappedComponent = (props: Props) => {
    const {
      address,
      getPeriods: getEnollmentPeriods,
      onExchange = true,
      productType = CORE_PRODUCT_TYPES.HEALTH,
    } = props;
    const enrollmentPeriods = useEnrollmentPeriods(getEnollmentPeriods, {
      state: address.state,
      onExchange,
      productType,
      planYear: getNextOepYear(),
    });
    return <Component {...props} enrollmentPeriods={enrollmentPeriods} />;
  };
  return connect(null, { getPeriods })(WrappedComponent);
};

export default withEnrollmentPeriodsHook;
